module.exports = __webpack_public_path__ + "img/text.b5321d34.png";